import type { CSSProperties } from 'react';

// Discover's existing Add Filter design, shared by the brand menu.
export const templateFilterTriggerStyle: CSSProperties = {
  display: 'flex', alignItems: 'center', gap: 5, padding: '5px 10px', borderRadius: 6,
  border: '1px solid transparent', background: 'transparent', color: '#526074',
  fontSize: 12, fontWeight: 500, cursor: 'pointer',
};
export const templateFilterPanelStyle: CSSProperties = {
  background: '#FFFFFF', border: '1px solid #DCE3ED', borderRadius: 12,
  boxShadow: '0 8px 24px rgba(0,0,0,0.12)', overflow: 'hidden',
  fontFamily: 'system-ui, sans-serif',
};
export const templateFilterItemStyle: CSSProperties = {
  width: '100%', display: 'flex', alignItems: 'center', gap: 8, padding: '8px 12px',
  fontSize: 12.5, lineHeight: 1.5, color: '#334155', background: 'transparent', border: 'none',
  cursor: 'pointer', fontWeight: 400, textAlign: 'left', borderRadius: 0,
};
export const templateCardActionStyle: CSSProperties = {
  width: 32, height: 32, borderRadius: 8, padding: 0,
  background: 'rgba(255,255,255,0.92)', color: '#1A1A1A',
  border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
  cursor: 'pointer', backdropFilter: 'blur(4px)',
};
